import React from "react";
import "./load.css";

function Loader() {
  return (
    <div className="loader-root">
      <div className="loader segment1">
        <span></span>
        <i></i>
      </div>
      <div className="loader segment2">
        <span></span>
        <i></i>
      </div>
      <div className="loader segment3">
        <span></span>
        <i></i>
      </div>
    </div>
  );
}

export default Loader;
